module.exports = __webpack_public_path__ + "static/resume-1ad97a45009ba0300f79ff25aa6563ce.pdf";